import { create } from 'zustand';
import { AccountApi, ApiUtils, type CreditLimitEntity, RequestStrategyEnum } from '@shared/api';

interface UseCreditLimitStore {
  loading: boolean;
  data: CreditLimitEntity | null;
  error: string | null;
  getCreditLimit: (accountId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useCreditLimitStore = create<UseCreditLimitStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  getCreditLimit: ApiUtils.wrapperApi(async (accountId, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await AccountApi.getCreditLimit(accountId, signal);
      set({ loading: false, data: result || null });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: null, error: null }),
}));
